import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function FailedMethods() {
  const failures = [{
    title: 'Cursos de 6 semanas',
    desc: 'Los cursos de entrenamiento tradicionales tardan 6 semanas en dar resultados, pero tú necesitas dormir hoy.'
  }, {
    title: 'Videos de YouTube',
    desc: 'Te enseñan a dar la pata, pero no cómo gestionar la ansiedad de un cachorro a medianoche.'
  }, {
    title: 'Refuerzo positivo sin estructura',
    desc: 'Solo le enseña a tu perro que si grita lo suficiente, recibirá un premio o tu atención.'
  }, {
    title: 'Castigos reactivos',
    desc: 'Los castigos después del hecho solo destruyen la confianza y hacen que el perro se esconda para orinar.'
  }];
  return <Section bg="cream" data-id="element-13">
      <div className="text-center mb-16" data-id="element-14">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-15">
          Por qué lo que has intentado{' '}
          <span className="text-softred" data-id="element-16">no funcionó</span>
        </h2>
        <div className="w-24 h-1 bg-softred mx-auto rounded-full" data-id="element-17"></div>
      </div>

      <div className="grid sm:grid-cols-2 gap-6 md:gap-8" data-id="element-18">
        {failures.map((item, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark flex flex-col" data-id="element-19">
            <div className="flex items-start gap-4 mb-4" data-id="element-20">
              <XCircle className="w-8 h-8 text-softred shrink-0 mt-1" data-id="element-21" />
              <h3 className="text-xl font-bold text-navy" data-id="element-22">{item.title}</h3>
            </div>
            <p className="text-navy/70 leading-relaxed ml-12" data-id="element-23">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}